import type { ApolloClientConfig } from '../types';

import {
	withAccessToken,
	withAuthMiddleware,
	withHeaders,
	withHttpLink,
	withNormalizedFullPath,
	withUploadHttpLink,
	withSGHeader,
} from '@/graphql/utils/links';

import { withSentryTracing } from '@/libraries/sentry/graphql';

export function getServerLinks({ headers, pinia }: ApolloClientConfig) {
	return [
		withNormalizedFullPath(),
		withSGHeader(pinia),
		withAccessToken(pinia),
		withAuthMiddleware(pinia),
		withHeaders(headers),
		// withRetry(),
		withSentryTracing(),
		withHttpLink(),
	];
}

export function getClientLinks({ headers, pinia }: ApolloClientConfig) {
	return [
		withNormalizedFullPath(),
		...(headers ? [withHeaders(headers)] : []),
		withSGHeader(pinia),
		withAccessToken(pinia),
		withAuthMiddleware(pinia),
		withUploadHttpLink(),
	];
}
